import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import useWindowDimensions from '@/hooks/useWindowDimensions';
import type { CardT } from '@/utils/contentfulTypes';
import { getTailwindBreakpoints } from '@/utils/misc';

interface AlterTestDriveProps {
  data: CardT;
}

export const AlterTestDrive = ({ data }: AlterTestDriveProps) => {
  const { width } = useWindowDimensions();
  const isMobile = !!width && width < getTailwindBreakpoints('md');
  return (
    <div className="relative flex h-[520px] bg-black p-6 pb-10 text-alter-bone md:h-[80vh] md:p-20 md:pb-10 md:items-center">
      <Image
        src={isMobile ? data.imageMobile.url : data.image.url}
        alt="Person working out with Alter system"
        fill
        className={clsx('object-cover')}
      />
      <div className="relative w-full width-1440 mt-auto flex flex-col gap-6 lg:mt-0">
        <h2 className="modernGothicTrial-light text-[32px] leading-snug md:text-5xl">
          {data.headline}
        </h2>
        <div className="modernGothicTrial-light text-alter-bone-80 text-[20px] leading-snug md:max-w-[50ch]">
          {data.text}
        </div>
        <Link href={data.buttonLink} className="button-primary w-max mt-4">
          {data.buttonText}
        </Link>
      </div>
    </div>
  );
};
